import * as types from './actionTypes';
import api from '../../../api/';

export function getData() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getCities();
      const topPicks = await api.getTSRecommends('EATERY');
      const localDelights = await api.getLocalRecommends();
      const topContributors = await api.getContributors();
      const nativeFood = await api.getNativeEateries();
      const experiences = await api.getExperiences();
      const localEateries = await api.getCityEateries();
      // const localArticles = await api.getFeaturedEatery(, 'STORY');
      const localArticles = await api.getFeaturedStoryForHP();
      dispatch({
        type: types.LOADED,
        cities,
        topPicks: topPicks,
        localDelights,
        topContributors,
        nativeFood,
        experiences,
        localEateries,
        localArticles,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
